import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MaintenanceScheduleStateService } from './+state/maintenance-schedule/maintenance-schedule-state.service';
import { MaintenanceScheduleEffects } from './+state/maintenance-schedule/maintenance-schedule.effects';
import { ServicesDueEffects } from './+state/services-due/services-due.effects';
import { TemplateDetailEffects } from './+state/template-detail/template-detail.effects';
import { VehicleMaintenanceEffects } from './+state/vehicle-maintenance.effects';
import { appReducer } from './+state/vehicle-maintenance.reducer';
import { VehicleMaintenanceStateService } from './vehicle-maintenance-state.service';
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('vehicleMaintenance', appReducer, {}),
    EffectsModule.forFeature([
      VehicleMaintenanceEffects,
      ServicesDueEffects,
      MaintenanceScheduleEffects,
      TemplateDetailEffects
    ])
  ],
  providers: [
    VehicleMaintenanceStateService,
    VehicleMaintenanceEffects,
    ServicesDueEffects,
    MaintenanceScheduleStateService,
    TemplateDetailEffects
  ]
})
export class XsrVehicleMaintenanceModule {}
